import Service from "../../Services";

const ResourceCenter = {
  namespaced : true,
  state : {
      form : {
        id : '',
        branch_id : '',
        title_th : '',
        title_en : '',
        description_en : '',
        description_th : '',
        attached_website : '',
        is_publish : true,
        slug_url : '',
        slide_images : [],
      },
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        title_th : '',
        title_en : '',
        description_en : '',
        description_th : '',
        attached_website : '',
        slug_url : '',
        is_publish : true,
        slide_images : [],
      }
    },
    SET_SLIDE_IMAGE: (state, data) => {
      state.form.slide_images = [
        ...state.form.slide_images,
        {
          ...data
        }
      ];
    },
    REMOVE_SLIDE_IMAGE: (state, index) => {
      state.form.slide_images = state.form.slide_images.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    }
  },
  actions : {
    getResourceCenter({commit},page){
      return Service.ResourceCenterAPI.getResourceCenter(page);
    },
    showResourceCenter({commit},id){
      return Service.ResourceCenterAPI.showResourceCenter(id);
    },
    saveResourceCenter({commit},{id,data}){
      if(id){
        return Service.ResourceCenterAPI.updateResourceCenter(id,data);
      }else{
        return Service.ResourceCenterAPI.createResourceCenter(data);
      }
    },
    deleteResourceCenter({commit},id){
      return Service.ResourceCenterAPI.deleteResourceCenter(id);
    },
    setFormResourceCenter({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    },
    insertSlideImage({ commit }, data) {
      commit("SET_SLIDE_IMAGE", data);
    },
    removeSlideImage({ commit }, index) {
      commit("REMOVE_SLIDE_IMAGE", index);
    }
  },
}
export default ResourceCenter
